import { Redirect, Route, Switch } from 'react-router-dom';
import { RouteWithApiError } from 'common/build/legacy/transcepta-ui-core';

import { routes } from './signup-portal.routes';

import { SupplierPages, Disclaimer, BuyerPages } from './pages';
import { Layout } from './Layout';

function App() {
    return (
        <Layout>
            <Switch>
                <Route
                    exact
                    path="/"
                    component={() => {
                        window.location.replace('https://www.transcepta.com');

                        return null;
                    }}
                />
                <Route exact path={routes.disclaimer.path}>
                    <Disclaimer />
                </Route>
                <Route path={routes.buyer.path}>
                    <Switch>
                        <RouteWithApiError exact path={routes.buyer.path}>
                            <BuyerPages.BuyerSignUp />
                        </RouteWithApiError>

                        <Redirect from="*" to={routes.buyer.path} />
                    </Switch>
                </Route>
                <Route exact path={routes.supplierLandingPage.path}>
                    <SupplierPages.LandingPage />
                </Route>
                <RouteWithApiError exact path={routes.supplierSignUpForm.path}>
                    <SupplierPages.SupplierSignUp />
                </RouteWithApiError>
                <RouteWithApiError exact path={routes.supplierPostSignup.path}>
                    <SupplierPages.PostSignupOrchestrator />
                </RouteWithApiError>
                <Route exact path={routes.supplierInvoiceSubmissionGuide.path}>
                    <SupplierPages.SubmissionGuide />
                </Route>

                <Redirect from="*" to="/" />
            </Switch>
        </Layout>
    );
}

export default App;
